import { render, staticRenderFns } from "./MachinesParametersTab.vue?vue&type=template&id=63475f6f&"
import script from "./MachinesParametersTab.vue?vue&type=script&lang=js&"
export * from "./MachinesParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports